export default function (store, { id }) {
    const task = store.getTask(id);
    if (!task?.collapsed)
        return;
    store.in.exec("update-task", {
        id,
        task: {
            ...task,
            collapsed: false,
        },
        skipProvider: true,
    });
}
//# sourceMappingURL=expand.js.map